export default {
  raised: "0 0.1rem 0.2rem rgba(0, 0, 0, 0.1), 0 0 0.2rem rgba(0, 0, 0, 0.2)",
  sticky: "0 0.2rem 0.4rem rgba(0, 0, 0, 0.1), 0 0 0.1rem rgba(0, 0, 0, 0.2)",
  overlay: "0 0.4rem 0.8rem rgba(0, 0, 0, 0.1), 0 0 0.1rem rgba(0, 0, 0, 0.2)",
  modal: "0 1.2rem 2.4rem rgba(0, 0, 0, 0.1), 0 0 0.1rem rgba(0, 0, 0, 0.2)"
};
